export default __webpack_public_path__ + "232009f0d47a43cd5a4e3f78145fcede.png";